export default __webpack_public_path__ + "static/media/icon-card-signature-permissions.c1924be8.svg";